/*eslint-disable*/
import api from './'

class GrageApi {

    // GET: grade/:id
    static show(id) {
        return api.axios.get('/grade/' + id)
            .then(response => response.data.grade);
    }

    // POST: grade
    static create(grade) {
        return api.axios.post('/grade', grade)
            .then(response => response.data.grade);
    }

    //PUT: grade/:id
    static update(id, grade) {
        return api.axios.put('/grade/' + id, grade)
            .then(response => response.data.grade)
    }


    // GET: grade
    static list(params, cancelToken = null) {
        return api.axios.get('/grade', {params, cancelToken})
            .then(response => response.data)
    }

    static delete(id) {
        return api.axios.delete('/grade/' + id)
            .then(response => response.data)
    }

    static exportList(params) {
        return api.axios.get('/grade/export', {params})
            .then(response => response.data)
    }

    static getPriceForActivate(id) {
        return api.axios.get(`grade/${id}/price-for-activate`)
            .then(response => response.data)
    }
}

export default GrageApi;